module.exports = __webpack_public_path__ + "static/media/coding.bde51ddc.svg";